import { render } from "./ProductPerformancePage.vue?vue&type=template&id=5e60fe8e"
import script from "./ProductPerformancePage.vue?vue&type=script&lang=js"
export * from "./ProductPerformancePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__